import React from 'react';

// Social Media Icons Configuration
const SOCIAL_ICONS = {
  instagram: {
    label: "اینستاگرام",
    colorClass: "hover:text-pink-500",
    path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
  },
  telegram: {
    label: "تلگرام",
    colorClass: "hover:text-blue-400",
    path: "M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
  },
  whatsapp: {
    label: "واتساپ",
    colorClass: "hover:text-green-500",
    path: "M13.601 2.326A7.854 7.854 0 1 0 7.926 15.75l-5.606 1.472 1.497-5.465a7.854 7.854 0 0 0 9.784-9.431zM10.84 14.19c-.38.19-2.247 1.108-2.593 1.235-.346.126-.597.19-.848.569-.253.38-1.006 1.265-1.233 1.522-.228.253-.454.284-.834.095-1.935-.965-3.208-2.688-4.45-4.848-.22-.382.22-.351.631-1.168.126-.253.063-.474-.032-.664-.095-.19-.848-2.043-1.161-2.798-.305-.735-.614-.636-.846-.648l-.722-.006c-.253 0-.664.095-1.011.474-.347.379-1.327 1.297-1.327 3.163s1.358 3.668 1.547 3.921c.189.253 2.673 4.084 6.476 5.726 2.585 1.117 3.111.895 3.674.842.923-.089 2.247-.917 2.563-1.801.316-.885.316-1.644.221-1.801-.094-.158-.347-.253-.727-.443z"
  },
  rubika: {
    label: "روبیکا",
    colorClass: "hover:text-purple-500",
    path: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-6h2v6zm4 0h-2v-8h2v8z"
  },
  eitaa: {
    label: "ایتا",
    colorClass: "hover:text-orange-500",
    path: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }
};

const SocialIcon = ({ type, url }) => {
  if (!url || !SOCIAL_ICONS[type]) return null;

  const { label, colorClass, path } = SOCIAL_ICONS[type];

  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer" 
      className={`w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 transition-all duration-300 ${colorClass} hover:bg-white hover:shadow-lg transform hover:-translate-y-1`}
      aria-label={label}
      title={label}
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path d={path} />
      </svg>
    </a>
  );
};

export default SocialIcon;
